import braintree from "braintree-web";

Alpine.data("SevenBraintreeThreeDSecure", (element) => {
    return ({
        verified: false,
        liabilityShiftPossible: false,
        liabilityShifted: false,

        async init() {
            document.addEventListener("braintree:client:init", async (event) => {
                const { client } = event.detail;

                try {
                    const instance = await braintree.threeDSecure.create({
                        client,
                        version: 2,
                    });

                    const verifyCard = async (payload) => {
                        const res = await new Promise((resolve, reject) => {
                            this._dispatchEvent('verifyCard', {
                                payload,
                                instance,
                                verifyCard: (params) => {
                                    resolve(instance.verifyCard({
                                        onLookupComplete: (data, next) => next(),
                                        ...params,
                                    }));
                                }
                            });
                        });

                        this.verified = true;
                        this.liabilityShifted = res.liabilityShifted;
                        this.liabilityShiftPossible = res.liabilityShiftPossible;

                        return res;
                    };

                    this._dispatchEvent("init", {
                        instance,
                        verifyCard
                    });
                } catch (error) {
                    this._dispatchEvent("error", { error });
                    throw error;
                }
            });
        },

        _dispatchEvent(name, { cancelable, bubbles, ...detail } = {}) {
            return element.dispatchEvent(new CustomEvent(`seven:braintree:threedsecure:${name}`, {
                detail,
                bubbles: bubbles ?? true,
                cancelable: cancelable ?? true
            }));
        }
    });
});


